module.exports = __webpack_public_path__ + "img/about-bg4.d5ce7377.png";